import { createContext, useContext } from 'react';
import { DEMO_ACCOUNT, type Account } from '@/navigation/current-account';

export interface AuthContextValue {
  account: Account;
  mode: 'entra' | 'demo';
  signOut?: () => Promise<void>;
}

export const AuthContext = createContext<AuthContextValue>({
  account: { name: 'Guest', email: '', role: '', workspace: '' },
  mode: 'entra'
});

/** Explicit fixture context for Storybook, tests, and the configured demo. */
export const demoAuthContext: AuthContextValue = { account: DEMO_ACCOUNT, mode: 'demo' };
export const useAuth = () => useContext(AuthContext);
